import React from 'react'
import { connect } from 'react-redux'
import * as Icons from 'components/Utils/Icons'
import Dropdown from 'components/base/Dropdown'
import { setActiveModal } from 'data/ui/actions'
import { SHORTCUTS } from 'components/Utils/Modal/constants'

function SupportDropdown({
  renderButtonFn,
  placement = 'left',
  placementCustomStyle = {},
  setActiveModal,
}) {
  const items = [
    {
      icon: Icons.PaperplaneIcon,
      title: 'Send a feature request',
      href: 'https://portal.productboard.com/slite',
    },
    {
      icon: Icons.ChatIcon,
      title: 'Chat with us',
      action: () => {
        window.Intercom
          ? window.Intercom('show')
          : window.open('mailto:contact@slite.com')
      },
    },
    {
      icon: Icons.QuestionIcon,
      title: 'Education center',
      href: 'https://help.slite.com',
    },
    {
      icon: Icons.SparklesIcon,
      title: "What's new?",
      href:
        'https://slite.com/api/s/eaa0f838-1935-48c7-b0dc-e34a2051ff17/Slite-Whats-New',
    },
    {
      icon: Icons.KeyboardIcon,
      title: 'Keyboard shortcuts',
      action: () => {
        setActiveModal({
          id: SHORTCUTS,
        })
      },
    },
  ]

  return (
    <Dropdown
      itemToString={item => (item ? item.title : '')}
      onSelect={item => {
        item.action && item.action()
      }}
    >
      {({
        getRootProps,
        getButtonProps,
        getItemProps,
        highlightedIndex,
        isOpen,
      }) => (
        <Dropdown.Wrapper {...getRootProps({ refKey: 'innerRef' })}>
          {renderButtonFn({ getButtonProps })}
          {isOpen && (
            <Dropdown.Body
              placement={placement}
              placementCustomStyle={placementCustomStyle}
            >
              {items.map((item, index) => (
                <a
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={item.href}
                >
                  <Dropdown.Item
                    {...getItemProps({ item, index })}
                    selected={highlightedIndex === index}
                    icon={
                      item.icon && (
                        <item.icon className={item.className} size={16} />
                      )
                    }
                  >
                    {item.title}
                  </Dropdown.Item>
                </a>
              ))}
            </Dropdown.Body>
          )}
        </Dropdown.Wrapper>
      )}
    </Dropdown>
  )
}

export default connect(
  null,
  { setActiveModal }
)(SupportDropdown)
